import dayjs from "dayjs";
import parseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(parseFormat);

export const generateTimeOptions = (selectedDate?: string) => {
  const options = [];
  const now = dayjs();
  const isToday = selectedDate ? dayjs(selectedDate).isSame(now, "day") : false;

  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const time = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;

      // If the selected date is today, filter out past times
      if (isToday) {
        const timeToCheck = dayjs().hour(hour).minute(minute);
        if (timeToCheck.isBefore(now)) {
          continue; // Skip this time if it's in the past
        }
      }

      const ampm = hour >= 12 ? "PM" : "AM";
      const displayHour = hour % 12 || 12;
      options.push({
        label: `${displayHour}:${minute.toString().padStart(2, "0")} ${ampm}`,
        value: time,
      });
    }
  }
  return options;
};

const isUTC = (dateString: string) => {
  return dateString.includes("+00:00") || dateString.endsWith("Z");
};

const handleTime = (timeString: string) => {
  if (isUTC(timeString)) {
    return dayjs(timeString, "HH:mm:ssZ").local().format("HH:mm");
  }
  return timeString;
};

export const addDurationToTime = (timeString: string, minutesToAdd: number) => {
  const newTimeString = handleTime(timeString);

  const timeParts = newTimeString.split(":");

  const hours = parseInt(timeParts[0] ?? "0", 10);
  const minutes = parseInt(timeParts[1] ?? "0", 10);

  if (isNaN(hours) || isNaN(minutes) || isNaN(minutesToAdd)) {
    return "00:00";
  }

  const totalMinutes = hours * 60 + minutes + minutesToAdd;
  const newHours = Math.floor(totalMinutes / 60);
  const newMinutes = totalMinutes % 60;
  return `${newHours.toString().padStart(2, "0")}:${newMinutes.toString().padStart(2, "0")}`;
};
